/**
 * Tauri auto-update — dynamic-import wrapper.
 *
 * In a plain browser the imports throw, so every call is gated on isDesktop
 * and the throw is swallowed → web build still loads.
 */

import { isDesktop } from './desktop';

export interface UpdateAvailable {
  available: true;
  version: string;
  currentVersion: string;
  notes?: string;
  date?: string;
  download: () => Promise<void>;
  install: () => Promise<void>;
  downloadAndInstall: (onChunk?: (bytes: number, total: number | undefined) => void) => Promise<void>;
}
export interface UpdateNone { available: false; currentVersion?: string; }
export type UpdateResult = UpdateAvailable | UpdateNone;

export async function checkForUpdate(): Promise<UpdateResult> {
  if (!isDesktop) return { available: false };
  try {
    const { check } = await import('@tauri-apps/plugin-updater');
    const upd = await check();
    if (!upd) return { available: false };
    return {
      available: true,
      version: upd.version,
      currentVersion: upd.currentVersion,
      notes: upd.body,
      date: upd.date,
      download: () => upd.download(),
      install: () => upd.install(),
      downloadAndInstall: (onChunk) => {
        let total: number | undefined;
        return upd.downloadAndInstall((evt: any) => {
          if (evt.event === 'Started') {
            total = evt.data.contentLength ?? undefined;
          } else if (evt.event === 'Progress' && onChunk) {
            onChunk(evt.data.chunkLength, total);
          }
        });
      },
    };
  } catch (e) {
    console.warn('[updater] check failed', e);
    return { available: false };
  }
}

export async function relaunchApp(): Promise<void> {
  if (!isDesktop) return;
  try {
    const { relaunch } = await import('@tauri-apps/plugin-process');
    await relaunch();
  } catch (e) {
    console.warn('[updater] relaunch failed', e);
  }
}
